import { Navigate, useLocation } from 'react-router-dom'

export function NotFound() {
  const location = useLocation()
  const pathname = location.pathname

  // 言語パスの場合はそのまま言語ルートへ
  if (pathname.startsWith('/ja') || pathname.startsWith('/en')) {
    // 言語パス内での404は言語トップへ
    const lang = pathname.startsWith('/ja') ? 'ja' : 'en'
    return <Navigate to={`/${lang}/`} replace />
  }

  // それ以外は通常のトップページへ
  return <Navigate to="/" replace />
}